(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tz-home-slider"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify && Shopify.designMode) {
    function prepareHomeSlider(root) {
      if (!root || !root.classList.contains('tz-home-slider-section') || !window.Swiper) return;
      root.querySelectorAll('.tz-inner-slider').forEach(function (el) {
        if (!el.swiper) new Swiper(el, {loop: false, slidesPerView: 1, spaceBetween: 20, grabCursor: true, autoHeight: true, autoplay: {delay: 4000}, pagination: false});
      });
      var outer = root.querySelector('.tz-outer-slider');
      if (outer && !outer.swiper) new Swiper(outer, {loop: false, slidesPerView: 1, spaceBetween: 20, grabCursor: true, autoHeight: true, pagination: {el: root.querySelector('.slider__pagination'), clickable: true}});
      var controls = root.querySelector('.slider__controls');
      if (controls && outer && outer.swiper) controls.style.display = outer.swiper.slides.length > 1 ? '' : 'none';
    }
    document.addEventListener('shopify:section:load', function (event) { prepareHomeSlider(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.classList.contains('tz-home-slider-section')) return;
      event.target.querySelectorAll('.swiper-container').forEach(function (el) { if (el.swiper) el.swiper.destroy(true, true); });
    });
    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('[data-product-image]');
      if (!slide) return;
      prepareHomeSlider(slide.closest('.tz-home-slider-section'));
      var inner = slide.closest('.tz-inner-slider');
      var outerSlide = slide.closest('.home-slide');
      var outer = outerSlide && outerSlide.closest('.tz-outer-slider');
      if (outer && outer.swiper) outer.swiper.slideTo(Array.prototype.indexOf.call(outer.swiper.slides, outerSlide), 0);
      if (inner && inner.swiper) {
        inner.swiper.autoplay.stop();
        inner.swiper.slideTo(Array.prototype.indexOf.call(inner.swiper.slides, slide), 0);
      }
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var slide = event.target.closest('[data-product-image]');
      var inner = slide && slide.closest('.tz-inner-slider');
      if (inner && inner.swiper) inner.swiper.autoplay.start();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
